// src/app/modules/demandes/DemandeFormModal.jsx
import React, { useEffect, useState } from "react";
import "../../RessourcesStyles/DemandeFormModal.css";

const defaultForm = {
    mode: "",
    period: "",
    niveau: "",
    certifiante: false,
    priorite: 2,
    objectifs: "",
    objectifs2: "",
    objectifs3: "",
    action: "",
    description: "",
    domaineId: "",
    themeId: "",
};

const PERIOD_OPTIONS = ["Q1", "Q2", "Q3", "Q4"];
const NIVEAU_OPTIONS = ["Débutant", "Intermédiaire", "Avancé"];
const MODE_OPTIONS = ["Distanciel", "Présentiel", "Hybride"];

export default function DemandeFormModal({
                                             open,
                                             onClose,
                                             onSubmit,
                                             formation, // {id, nom, ...}
                                             campagneId, // id campagne sélectionnée
                                             type = "FORMATION", // "FORMATION" | "HORS_CATALOGUE"
                                             domaines = [],
                                             themes = [],
                                         }) {
    const [form, setForm] = useState(defaultForm);

    useEffect(() => {
        if (!open) return;
        setForm((prev) => ({
            ...defaultForm,
            // keep last choices? non: reset propre à chaque ouverture
            priorite: 2,
        }));
    }, [open]);

    if (!open) return null;

    const update = (k, v) => setForm((s) => ({ ...s, [k]: v }));

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            campagneId,
            type,
            formationId: type === "FORMATION" ? formation?.id : null,

            mode: form.mode || null,
            period: form.period || null,
            niveau: form.niveau || null,
            certifiante: !!form.certifiante,
            priorite: form.priorite === "" ? null : Number(form.priorite),

            objectifs: form.objectifs || null,
            objectifs2: form.objectifs2 || null,
            objectifs3: form.objectifs3 || null,

            // hors catalogue
            action: form.action || null,
            description: form.description || null,
            domaineId: form.domaineId ? Number(form.domaineId) : null,
            themeId: form.themeId ? Number(form.themeId) : null,
        };

        onSubmit?.(payload);
    };

    return (
        <div className="demande-modal-overlay" onMouseDown={onClose}>
            <div
                className="demande-modal"
                onMouseDown={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <div className="demande-modal-header">
                    <div className="demande-modal-title">
                        {type === "FORMATION" ? "Demander une formation" : "Demande hors catalogue"}
                    </div>
                    <button className="demande-modal-close" onClick={onClose} type="button">
                        ✕
                    </button>
                </div>

                <div className="demande-modal-subtitle">
                    {type === "FORMATION" ? (
                        <span>
              Formation : <b>{formation?.nom || formation?.name || "—"}</b>
            </span>
                    ) : (
                        <span>Merci de renseigner les informations</span>
                    )}
                </div>

                <form className="demande-form" onSubmit={handleSubmit}>
                    <div className="demande-grid-2">
                        <div className="field">
                            <label>Mode</label>
                            <select value={form.mode || ""} onChange={(e) => update("mode", e.target.value)}>
                                <option value="">—</option>
                                {MODE_OPTIONS.map((m) => (
                                    <option key={m} value={m}>
                                        {m}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="field">
                            <label>Période</label>
                            <select value={form.period || ""} onChange={(e) => update("period", e.target.value)}>
                                <option value="">—</option>
                                {PERIOD_OPTIONS.map((p) => (
                                    <option key={p} value={p}>
                                        {p}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="field">
                            <label>Niveau</label>
                            <select value={form.niveau || ""} onChange={(e) => update("niveau", e.target.value)}>
                                <option value="">—</option>
                                {NIVEAU_OPTIONS.map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="field">
                            <label>Priorité</label>
                            <select value={form.priorite} onChange={(e) => update("priorite", e.target.value)}>
                                <option value={1}>1 - Haute</option>
                                <option value={2}>2 - Moyenne</option>
                                <option value={3}>3 - Basse</option>
                            </select>
                        </div>

                        <div className="field field-inline">
                            <label>Certifiante</label>
                            <input
                                type="checkbox"
                                checked={!!form.certifiante}
                                onChange={(e) => update("certifiante", e.target.checked)}
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label>Objectifs (1)</label>
                        <textarea value={form.objectifs} onChange={(e) => update("objectifs", e.target.value)} />
                    </div>
                    <div className="field">
                        <label>Objectifs (2)</label>
                        <textarea value={form.objectifs2} onChange={(e) => update("objectifs2", e.target.value)} />
                    </div>
                    <div className="field">
                        <label>Objectifs (3)</label>
                        <textarea value={form.objectifs3} onChange={(e) => update("objectifs3", e.target.value)} />
                    </div>

                    {type === "HORS_CATALOGUE" && (
                        <>
                            <div className="demande-grid-2">
                                <div className="field">
                                    <label>Domaine</label>
                                    <select value={form.domaineId} onChange={(e) => update("domaineId", e.target.value)}>
                                        <option value="">—</option>
                                        {domaines.map((d) => (
                                            <option key={d.id} value={d.id}>
                                                {d.nom || d.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="field">
                                    <label>Thème</label>
                                    <select value={form.themeId} onChange={(e) => update("themeId", e.target.value)}>
                                        <option value="">—</option>
                                        {themes.map((t) => (
                                            <option key={t.id} value={t.id}>
                                                {t.nom || t.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="field">
                                <label>Action / Intitulé</label>
                                <input value={form.action} onChange={(e) => update("action", e.target.value)} />
                            </div>

                            <div className="field">
                                <label>Description</label>
                                <textarea
                                    value={form.description}
                                    onChange={(e) => update("description", e.target.value)}
                                    rows={5}
                                />
                            </div>
                        </>
                    )}

                    <div className="demande-actions">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={!campagneId}>
                            Envoyer la demande
                        </button>
                    </div>

                    {!campagneId && <div className="demande-hint">⚠️ Sélectionne d’abord une campagne.</div>}
                </form>
            </div>
        </div>
    );
}
